import { mediaRotationService } from '@/api/media-rotation.service';
import type { RotationMediaPoolItemDto } from '@carvia/ros-client-types';
import { MEDIA_ROTATION_QUERY_KEY } from '@/queries/use-media-rotation';
import { useQuery } from '@tanstack/vue-query';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';

const POOL_REFETCH_INTERVAL_MS = 5 * 60 * 1000;

export const useMediaRotationCurrent = (
  enabled: MaybeRefOrGetter<boolean> = true,
  stationSlug?: MaybeRefOrGetter<string | undefined>,
  stationAuthCode?: MaybeRefOrGetter<string | undefined>,
) => {
  return useQuery<RotationMediaPoolItemDto[]>({
    queryKey: computed(() => [
      MEDIA_ROTATION_QUERY_KEY,
      'current',
      toValue(stationSlug),
      toValue(stationAuthCode),
    ]),
    queryFn: () => {
      const slug = toValue(stationSlug);
      return slug
        ? mediaRotationService.getVideoWallCurrent(slug, toValue(stationAuthCode))
        : mediaRotationService.getCurrent();
    },
    enabled: () => toValue(enabled),
    refetchInterval: POOL_REFETCH_INTERVAL_MS,
    placeholderData: (previousData) => previousData,
  });
};
